import script from "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=style&index=0&id=5ff7d5bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff7d5bf"]])

export default __exports__